import React, { useEffect, useId, useRef, useState } from 'react';

function RibbonShape({ gradientId }) {
  return (
    <>
      <path d="M 1120 -100 C 1420 160 1030 265 1050 425 C 1075 620 1500 640 1600 990 L 1680 -100 Z" fill={`url(#${gradientId})`} />
      <path d="M 1230 -100 C 1530 170 1080 290 1110 455 C 1140 620 1520 675 1600 990" stroke="#FFFFFF" strokeWidth="2" strokeOpacity=".65" />
    </>
  );
}

/** Diffused ribbons of light; CSS owns motion without a rendering loop. */
export default function HeroBackground({ isDark }) {
  const id = useId().replace(/:/g, '');
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    let visible = true;
    const update = () => setActive(visible && !document.hidden);
    const observer = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      update();
    });
    observer?.observe(ref.current);
    document.addEventListener('visibilitychange', update);
    update();
    return () => {
      observer?.disconnect();
      document.removeEventListener('visibilitychange', update);
    };
  }, []);

  return (
    <div ref={ref} data-hero-background={isDark ? 'dark' : 'light'} data-active={active} aria-hidden="true">
      <svg viewBox="0 0 1440 900" preserveAspectRatio="none" fill="none" focusable="false">
        <defs>
          <linearGradient id={`${id}-ribbon`} x1="1000" y1="150" x2="1540" y2="700" gradientUnits="userSpaceOnUse">
            <stop stopColor="#EFF7FD" />
            <stop offset=".32" stopColor="#B5D9F2" />
            <stop offset=".58" stopColor="#88BCE1" />
            <stop offset=".8" stopColor="#DCECF8" />
            <stop offset="1" stopColor="#F7FBFE" />
          </linearGradient>
        </defs>
        <g data-hero-light="ribbon">
          <RibbonShape gradientId={`${id}-ribbon`} />
        </g>
        <g transform="translate(1440 0) scale(-1 1)">
          <g data-hero-light="echo">
            <RibbonShape gradientId={`${id}-ribbon`} />
          </g>
        </g>
      </svg>
      <div data-hero-light-veil />
    </div>
  );
}
